'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import type { DehydratedState } from '@tanstack/react-query';
import { QueryProvider as BaseQueryProvider } from '@workspace/ui/providers';
import { WALLET_QUERY_STALE_TIME } from '@/components/providers/get-query-provider';

interface QueryProviderProps {
  children: React.ReactNode;
  dehydratedState?: DehydratedState;
}

export function QueryProvider({ children, dehydratedState }: QueryProviderProps) {
  return (
    <BaseQueryProvider dehydratedState={dehydratedState} staleTime={WALLET_QUERY_STALE_TIME}>
      {children}
    </BaseQueryProvider>
  );
}
